async function getPushDeviceToken(): Promise<string | undefined> {
  if (!(window as any).naverappapi) return;

  return new Promise<string>(resolve => {
    function handlePushDeviceToken(event: any) {
      resolve(JSON.stringify(event.detail));
      window.removeEventListener('pushDeviceToken', handlePushDeviceToken);
    }

    window.addEventListener('pushDeviceToken', handlePushDeviceToken);

    (window as any).naverappapi.getPushDeviceToken();
  });
}

export { getPushDeviceToken };
